/* === Reviews JS (v5 – lazy load + company paragraph + product-aware themes) === */
(function(){
  const cfg = window.LLS_REVIEWS || {};
  const $  = (sel, root=document) => root.querySelector(sel);
  const $$ = (sel, root=document) => Array.from(root.querySelectorAll(sel));

  const starSVG = '<svg aria-hidden="true" width="14" height="14" viewBox="0 0 20 20" fill="#FFD700"><path d="M10 15l-6.16 3.24 1.18-6.88L0 6.76l6.92-1.01L10 0l3.08 5.75L20 6.76l-5.02 4.6 1.18 6.88z"/></svg>';
  const stars = n => { n=parseInt(n||0); return Array.from({length:n}).map(()=>starSVG).join(''); };
  const esc   = s => (s==null?'':String(s)).replaceAll('&','&amp;').replaceAll('<','&lt;').replaceAll('>','&gt;');
  const getJSON = async url => (await fetch(url,{credentials:'same-origin'})).json();

  let prodDataCache = null;
  let tpDataCache   = null;

  /* ----------- Helpers ----------- */
  function computeServiceSummary(tp){
    const count = tp.length;
    if (!count) return { count: 0, avg: 0, pct_5star: 0 };
    const sum = tp.reduce((a,r)=> a + (parseInt(r.rating||0)||0), 0);
    const avg = +(sum / count).toFixed(2);
    const pct_5star = +((tp.filter(r => (r.rating||0) >= 5).length / count) * 100).toFixed(1);
    return { count, avg, pct_5star };
  }

  function buildCompanyParagraph(tpData, svc){
    const total = svc?.count || tpData.length || 0;
    const avg   = svc?.avg ? Number(svc.avg).toFixed(2) : '-';
    const hiPct = tpData.length ? Math.round((tpData.filter(r => (r.rating||0) >= 4).length / tpData.length) * 100) : 0;
    const texts = tpData.map(r => (r.text || '').toLowerCase());
    let themes = [];
    if (texts.some(t => t.includes('delivery'))) themes.push('fast delivery');
    if (texts.some(t => t.includes('service') || t.includes('support'))) themes.push('responsive customer service');
    if (texts.some(t => t.includes('quality'))) themes.push('high product quality');
    if (texts.some(t => t.includes('value') || t.includes('price'))) themes.push('good value for money');
    if (!themes.length) themes = ['service and product quality'];
    const themeSentence = `Customers frequently praise our ${themes.slice(0, -1).join(', ')}${themes.length > 1 ? ' and ' + themes.slice(-1) : ''}.`;
    return `With over ${total.toLocaleString()} verified Trustpilot reviews, we maintain an average score of ${avg}/5, with ${hiPct}% rating us 4–5★. ${themeSentence}`;
  }

  // --- Product-specific theme detector ---
  function detectProductThemes(title, texts){
    const t = (title || '').toLowerCase();
    const blob = texts.join(' || ').toLowerCase();
    const seen = (...res) => res.some(re => re.test(blob));

    const rules = [
  {
    match: /(ashwagandha|ksm-66|shoden)/i,
    themes: [
      ['stress support', /stress|cortisol|anxious|anxiety|calm/],
      ['better sleep', /sleep|insomnia|restful|deep\s+sleep/],
      ['mood balance', /mood|irritable|wellbeing|balance/]
    ]
  },
  {
    match: /(berberine)/i,
    themes: [
      ['blood sugar control', /sugar|glucose|blood\s*sugar|insulin/],
      ['weight management', /weight|fat|metabolism/],
      ['gut health', /digestion|gut|microbiome/]
    ]
  },
  {
    match: /(creatine|creapure|creavitalis)/i,
    themes: [
      ['strength & performance', /strength|power|performance|lifts|gym/],
      ['faster recovery', /recovery|soreness|doms|repair/],
      ['muscle & size', /muscle|mass|size|hypertrophy/]
    ]
  },
  {
    match: /(lion'?s\s*mane|hericium)/i,
    themes: [
      ['focus & clarity', /focus|concentration|clarity|brain\s*fog/],
      ['memory & cognition', /memory|recall|cognitive|learning/],
      ['calm productivity', /calm|smooth|balanced|anxiety/]
    ]
  },
  {
    match: /(shilajit|fulvic)/i,
    themes: [
      ['better energy', /energy|fatigue|tired|vitality/],
      ['hormonal balance', /testosterone|libido|hormone/],
      ['overall wellbeing', /wellbeing|resilience|vitality/]
    ]
  },
  {
    match: /(magnesium|glycinate|bisglycinate|mag 7)/i,
    themes: [
      ['better sleep', /sleep|insomnia|restful|night/],
      ['muscle relaxation', /cramps|spasms|twitch|relax/],
      ['calm & stress', /calm|anxiety|stress/]
    ]
  },
  {
    match: /(marine collagen skin boost\+|skin boost|astaxanthin)/i,
    themes: [
      ['skin, hair & nails', /skin|hair|nails|complexion|glow/],
      ['anti-ageing', /wrinkles|elasticity|youthful/],
      ['joint support', /joint|cartilage|mobility/]
    ]
  },
  {
    match: /(marine collagen|collagen peptides)/i,
    themes: [
      ['skin, hair & nails', /skin|hair|nails|complexion|glow/],
      ['joint & bone support', /joint|cartilage|bone|mobility/],
      ['gut health', /digestion|gut|bloating|stomach/]
    ]
  },
  {
    match: /(vitamin b-complex)/i,
    themes: [
      ['energy & fatigue', /energy|fatigue|tired|exhausted/],
      ['nervous system support', /nerves|neuropathy|nervous/],
      ['mental clarity', /focus|concentration|clarity/]
    ]
  },
  {
    match: /(vitamin d3|k2)/i,
    themes: [
      ['bone & immunity', /bone|immune|immunity|cold|flu/],
      ['mood & energy', /mood|energy|fatigue|tired/],
      ['absorption', /absorb|absorption|with\s+food/]
    ]
  },
  {
    match: /(omega|fish oil|epa|dha|vegan omega)/i,
    themes: [
      ['heart & cholesterol', /heart|cholesterol|triglycerides/],
      ['brain & focus', /brain|focus|memory|cognition/],
      ['joints & inflammation', /joint|inflammation|stiff/]
    ]
  },
  {
    match: /(probiotic|multispore|lactospore)/i,
    themes: [
      ['gut balance', /gut|microbiome|regular|bowel/],
      ['bloating & digestion', /bloat|digestion|gas|stomach/],
      ['immunity support', /immune|immunity|cold/]
    ]
  },
  {
    match: /(turmeric|curcumin|boswellia|joint support)/i,
    themes: [
      ['joints & mobility', /joint|mobility|stiff|ache/],
      ['inflammation support', /inflammation|swelling|soreness/],
      ['comfort & recovery', /comfort|recovery|relief/]
    ]
  },
  {
    match: /(rhodiola)/i,
    themes: [
      ['stress resilience', /stress|burnout|fatigue/],
      ['focus & stamina', /focus|concentration|stamina/],
      ['mood balance', /mood|motivation|drive/]
    ]
  },
  {
    match: /(cordyceps)/i,
    themes: [
      ['energy & endurance', /energy|endurance|stamina/],
      ['oxygen utilisation', /oxygen|vo2|max|aerobic/],
      ['recovery', /recovery|fatigue|tired/]
    ]
  },
  {
    match: /(reishi)/i,
    themes: [
      ['calm & relaxation', /calm|relax|sleep/],
      ['immunity support', /immune|immunity|cold|flu/],
      ['overall wellbeing', /wellbeing|balance|resilience/]
    ]
  },
  {
    match: /(chaga)/i,
    themes: [
      ['immunity support', /immune|immunity|antioxidant/],
      ['antioxidant support', /antioxidant|oxidative/],
      ['energy & vitality', /energy|vitality|stamina/]
    ]
  },
  {
    match: /(mct powder|mct oil)/i,
    themes: [
      ['clean energy', /energy|fuel|ketone|ketosis/],
      ['mental clarity', /focus|concentration|clarity/],
      ['digestion friendly', /digestion|stomach|gut/]
    ]
  },
  {
    match: /(greens|reds|superfood)/i,
    themes: [
      ['daily nutrition', /nutrition|nutrients|greens|superfood/],
      ['energy & vitality', /energy|vitality|stamina/],
      ['digestion support', /digestion|gut|bloating/]
    ]
  },
  {
    match: /(matcha|green tea)/i,
    themes: [
      ['clean energy', /energy|alert|focus/],
      ['antioxidant support', /antioxidant|catechins/],
      ['metabolism support', /metabolism|weight/]
    ]
  },
  {
    match: /(charcoal|activated charcoal)/i,
    themes: [
      ['detox support', /detox|toxin|cleanse/],
      ['digestion support', /digestion|gut|stomach/],
      ['bloating relief', /bloat|gas/]
    ]
  },
  {
    match: /(resveratrol)/i,
    themes: [
      ['anti-ageing', /anti[- ]?age|longevity/],
      ['heart health', /heart|cholesterol/],
      ['antioxidant support', /antioxidant/]
    ]
  },
  {
    match: /(ginkgo)/i,
    themes: [
      ['memory & cognition', /memory|recall|cognition/],
      ['circulation', /circulation|blood flow/],
      ['focus & clarity', /focus|concentration|clarity/]
    ]
  },

  // === GENERIC FALLBACK ===
  {
    match: /.*/,
    themes: [
      ['better energy', /energy|tired|fatigue/],
      ['better sleep', /sleep|restful|insomnia/],
      ['improved focus', /focus|clarity|concentration/],
      ['high product quality', /quality|premium|pure/],
      ['good value', /value|price|money/]
    ]
  }
];


    const rule = rules.find(r => r.match.test(t));
    const picked = [];

    if (rule){
      rule.themes.forEach(([label, regex]) => { if (regex.test(blob)) picked.push(label); });
    }

    if (!picked.length){
      if (seen(/energy/)) picked.push('better energy');
      if (seen(/sleep/)) picked.push('better sleep');
      if (seen(/focus|clarity/)) picked.push('improved focus');
      if (seen(/quality|pure|premium/)) picked.push('high product quality');
    }

    return [...new Set(picked)].slice(0,3);
  }

  function buildProductParagraph(list, title){
    const total = list.length;
    if (!total) return `No reviews yet for ${title}.`;

    const sum   = list.reduce((a,r)=> a+(parseInt(r.rating||0)||0),0);
    const avg   = (sum / total).toFixed(2);
    const hiPct = Math.round((list.filter(r => (r.rating||0) >= 4).length / total) * 100);
    const texts = list.map(r => (r.text || ''));

    const themes = detectProductThemes(title, texts);
    const themeSentence = themes.length
      ? `Common positives include ${themes.slice(0,2).join(', ')}${themes[2] ? ' and ' + themes[2] : ''}.`
      : `Customers frequently highlight its quality and effectiveness.`;

    return `Based on ${total} verified reviews for ${title}, the average rating is ${avg}/5 and ${hiPct}% rate it 4–5★. ${themeSentence}`;
  }

  /* ----------- Init & Rendering ----------- */
  async function init(){
  // Fetch summaries immediately
  const [prodSummary, svcSummaryRaw, tpMaybe] = await Promise.all([
    getJSON(cfg.productSummaryUrl),
    getJSON(cfg.serviceSummaryUrl),
    getJSON(cfg.trustpilotDataUrl).catch(()=>[])  // small cost to ensure service rating works
  ]);

  // Compute fallback service summary if needed
  const svcSummary = (svcSummaryRaw && Number(svcSummaryRaw.avg))
    ? svcSummaryRaw
    : computeServiceSummary(tpMaybe);

  // Render the top stats
  renderStats(svcSummary, prodSummary);

  // Render the product summaries grid straight away
  renderProductSummaries(prodSummary, {});  // no prodData yet

  // Tabs: clicking will lazy-load heavy JSON
  setupTabs(prodSummary, svcSummary);

  // Schema.org injection
  injectSchema(svcSummary, prodSummary);
}


  function renderStats(svcSummary, prodSummary){
  const el = document.getElementById('lls-stats');

  const totalProductReviews = prodSummary.reduce((a,r)=> a + (r.count||0), 0);
  const avgNum = prodSummary.length
    ? (prodSummary.reduce((a,r)=> a+Number(r.avg||0),0) / prodSummary.length)
    : 0;
  const avgOfAverages = avgNum ? avgNum.toFixed(2) : '-';

  el.innerHTML = `
    <!-- Click → Company tab -->
    <div class="lls-card lls-card--click" data-target="company" role="button" tabindex="0" aria-label="View company reviews">
      <div><strong>Service Rating (Trustpilot)</strong></div>
      <div class="lls-score-row">
        <div class="lls-score">${svcSummary?.avg || '-'}</div>
        <div class="lls-stars">${svcSummary?.avg ? stars(Math.round(svcSummary.avg)) : ''}</div>
      </div>
      <div class="lls-sub">${svcSummary?.count || 0} reviews • ${svcSummary?.pct_5star || 0}% 5★</div>
    </div>

    <!-- Click → Product tab -->
    <div class="lls-card lls-card--click" data-target="product" role="button" tabindex="0" aria-label="View product reviews">
      <div><strong>Total Product Reviews</strong></div>
      <div class="lls-score">${totalProductReviews}</div>
      <div class="lls-sub">Across all active supplements</div>
    </div>

    <!-- Click → Product tab, WITH STARS -->
    <div class="lls-card lls-card--click" data-target="product" role="button" tabindex="0" aria-label="View average product rating">
      <div><strong>Avg Product Rating</strong></div>
      <div class="lls-score-row">
        <div class="lls-score">${avgOfAverages}</div>
        <div class="lls-stars">${avgNum ? stars(Math.round(avgNum)) : ''}</div>
      </div>
      <div class="lls-sub">Mean of product averages</div>
    </div>
  `;

  // Make tiles switch tabs on click/keyboard
  const switchTab = (name) => {
    const btn = document.querySelector(`#lls-testimonials .lls-tab[data-tab="${name}"]`);
    if (btn) btn.click();
  };
  document.querySelectorAll('#lls-stats .lls-card--click').forEach(card => {
  card.addEventListener('click', ()=> {
    switchTab(card.dataset.target);

    // 🔹 Jump to correct section after tab switch
    if (card.dataset.target === 'company'){
      document.getElementById('lls-company').scrollIntoView({behavior:'smooth'});
    } else {
      document.getElementById('lls-product').scrollIntoView({behavior:'smooth'});
    }
  });

  card.addEventListener('keydown', (e)=> {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      switchTab(card.dataset.target);
      if (card.dataset.target === 'company'){
        document.getElementById('lls-company').scrollIntoView({behavior:'smooth'});
      } else {
        document.getElementById('lls-product').scrollIntoView({behavior:'smooth'});
      }
    }
  });
});

}


  function setupTabs(prodSummary, svcSummary){
  $$('#lls-testimonials .lls-tab').forEach(tab => {
    tab.addEventListener('click', async () => {
      $$('#lls-testimonials .lls-tab').forEach(x => x.classList.remove('active'));
      tab.classList.add('active');

      if (tab.dataset.tab === 'company'){
        $('#lls-product').classList.add('hidden');
        $('#lls-company').classList.remove('hidden');

        if (!tpDataCache){
          tpDataCache = await getJSON(cfg.trustpilotDataUrl);
          const svc = (svcSummary && Number(svcSummary.avg)) ? svcSummary : computeServiceSummary(tpDataCache);
          renderCompany(tpDataCache, svc);
        }
      } else {
        $('#lls-company').classList.add('hidden');
        $('#lls-product').classList.remove('hidden');

        // Render summaries if not already shown
        if (!$('#lls-product-summaries').innerHTML.trim()){
          renderProductSummaries(prodSummary, prodDataCache || {});
        }

        // Preload reviews JSON if not yet fetched
        if (!prodDataCache){
          prodDataCache = await getJSON(cfg.productDataUrl);
        }
      }
    });
  });

  // 🔹 NEW: handle star clicks before tab switch
  $('#lls-product-summaries').addEventListener('click', async (e) => {
    const el = e.target.closest('[data-jump]');
    if (!el) return;

    if (!prodDataCache){
      prodDataCache = await getJSON(cfg.productDataUrl); // fetch on first click
    }

    const key = el.getAttribute('data-jump');
    const list = (prodDataCache[key] || []).slice().sort((a,b)=> new Date(b.date) - new Date(a.date));
    const container = $('#lls-product-reviews');
    if (!list.length){
      container.innerHTML = '<div class="lls-small">No reviews to display for this product.</div>';
      return;
    }
    renderProductReviews(list, key, container);
    container.scrollIntoView({behavior:'smooth'});
  });

  // 🔹 NEW: background preload after page idle
  if ('requestIdleCallback' in window){
    requestIdleCallback(async () => {
      if (!prodDataCache){
        try { prodDataCache = await getJSON(cfg.productDataUrl); } catch(e){}
      }
    }, {timeout: 3000});
  } else {
    setTimeout(async () => {
      if (!prodDataCache){
        try { prodDataCache = await getJSON(cfg.productDataUrl); } catch(e){}
      }
    }, 3000);
  }
}


  function renderProductSummaries(rows, prodData){
    const wrap = $('#lls-product-summaries');
    wrap.innerHTML = rows.map(r => {
      const title  = esc(r.canonical_title || r.canonical_handle || 'Product');
      const handle = esc(r.canonical_handle || '');
      const avg    = esc(r.avg);
      const cnt    = esc(r.count);
      const pct    = esc(r.pct_5star);
      const key    = esc(r.canonical_title || r.canonical_handle || 'Unknown Product');
      return `
        <div class="lls-card">
          <div class="lls-prod-head">
            <h3 data-product="${key}" style="margin:0">${title}</h3>
            <div class="lls-score-row" role="button" tabindex="0" aria-label="Show ${cnt} reviews for ${title}" data-jump="${key}">
              <div class="lls-score">${avg}</div>
              <div class="lls-stars" data-jump="${key}" aria-hidden="true">${stars(Math.round(avg))}</div>
              <div class="lls-count">${cnt} reviews</div>
            </div>
            <div class="lls-sub">${pct}% 5★</div>
            <span class="lls-hint" data-jump="${key}"></span>
            ${handle ? `<div class="lls-sub"><a href="/products/${handle}" target="_blank" rel="noopener">View product</a></div>` : ``}
          </div>
        </div>
      `;
    }).join('');

    // Bind clicks
    const container = $('#lls-product-reviews');
    container.innerHTML = '<div class="lls-small">Select a product to view reviews.</div>';

    $$('#lls-product-summaries [data-jump]').forEach(el => {
      el.addEventListener('click', () => {
        const key = el.getAttribute('data-jump');
        const list = (prodData[key] || []).slice().sort((a,b)=> new Date(b.date) - new Date(a.date));
        if (!list.length){
          container.innerHTML = '<div class="lls-small">No reviews to display for this product.</div>';
          return;
        }
        renderProductReviews(list, key, container);
        container.scrollIntoView({behavior:'smooth'});
      });
    });
  }

  function renderProductReviews(list, title, container, pageIndex=0){
    const PAGE = cfg.pageSize || 20;
    const end = Math.min((pageIndex+1)*PAGE, list.length);
    let html = `
      <div style="display:flex;justify-content:space-between;align-items:center;">
        <strong>${esc(title)}</strong>
        <button class="lls-load" id="lls-clear">Clear</button>
      </div>
      <p class="lls-product-text">${esc(buildProductParagraph(list, title))}</p>
    `;
    for (let i=0;i<end;i++){
      const d = list[i];
      html += `
        <div class="lls-review">
          <div><strong>${esc(d.name || 'Customer')}</strong> • <span class="lls-small">${esc(d.date || '')}</span></div>
          <div class="lls-stars">${stars(parseInt(d.rating||0))} <span class="lls-small" style="margin-left:6px">${esc(d.rating)}★</span></div>
          <div style="margin-top:6px">${esc(d.text)}</div>
        </div>
      `;
    }
    if (end < list.length) html += `<button class="lls-load" id="lls-more">Load more</button>`;
    container.innerHTML = html;
    $('#lls-clear')?.addEventListener('click', ()=> container.innerHTML = '<div class="lls-small">Select a product to view reviews.</div>');
    $('#lls-more')?.addEventListener('click', ()=> renderProductReviews(list, title, container, pageIndex+1));
  }

  function renderCompany(tpData, svcSummary){
    const wrap = $('#lls-company-reviews');
    const first = tpData.slice(0, 40);
    const rest  = tpData.slice(40);
    const paragraph = `<p class="lls-company-text">${esc(buildCompanyParagraph(tpData, svcSummary))}</p>`;
    const mk = r => `
      <div class="lls-review">
        <div><strong>${esc(r.name || 'Customer')}</strong> • <span class="lls-small">${esc(r.date || '')}</span></div>
        <div class="lls-stars">${stars(parseInt(r.rating||0))} <span class="lls-small" style="margin-left:6px">${esc(r.rating)}★</span></div>
        <div style="margin-top:6px">${esc(r.text)}</div>
      </div>
    `;
    wrap.innerHTML = paragraph + first.map(mk).join('') + (rest.length
      ? `<button class="lls-load" id="lls-company-more">Load more</button><div id="lls-company-rest" class="hidden">${rest.map(mk).join('')}</div>`
      : ''
    );
    $('#lls-company-more')?.addEventListener('click', ()=> { $('#lls-company-rest').classList.remove('hidden'); $('#lls-company-more').remove(); });
  }

  function injectSchema(serviceSummary, productSummary){
    try{
      const org = {"@context":"https://schema.org","@type":"Organization","name":"Love Life Supplements","url":window.location.origin,"aggregateRating":{"@type":"AggregateRating","ratingValue": Number(serviceSummary?.avg || 0),"reviewCount": Number(serviceSummary?.count || 0)}};
      const s1 = document.createElement('script'); s1.type = 'application/ld+json'; s1.textContent = JSON.stringify(org); document.head.appendChild(s1);
      const top = (productSummary || []).slice().sort((a,b)=> (b.count||0) - (a.count||0)).slice(0,12);
      top.forEach(p => {
        const prod = {"@context":"https://schema.org","@type":"Product","name": p.canonical_title || p.canonical_handle || "Product","brand":{"@type":"Brand","name":"Love Life Supplements"},"aggregateRating":{"@type":"AggregateRating","ratingValue": Number(p.avg || 0),"reviewCount": Number(p.count || 0)}};
        const s = document.createElement('script'); s.type = 'application/ld+json'; s.textContent = JSON.stringify(prod); document.head.appendChild(s);
      });
    } catch(e){ console.warn('Schema injection failed', e); }
  }

  init().catch(err => {
    console.error('LLS reviews init error', err);
    $('#lls-testimonials')?.insertAdjacentHTML('beforeend','<p class="lls-small">Unable to load reviews right now.</p>');
  });
})();
